
export const zenLoginSelectors = {
    button: '.zen-login-cta__options',
    mobileButton: '.zen-login-cta__options_mobile',
    menu: '.zen-login-cta__menu',
    menuOpen: 'zen-login-cta__menu--open',
    menuState: 'closed',
    buttonOpen: 'zen-login-cta__options--open',
    buttonClosed: 'zen-login-cta__options--closed',
    mobileButtonOpen: 'zen-login-cta__options_mobile--open',
    mobileButtonClosed: 'zen-login-cta__options_mobile--closed'
};

export const loginSelectors = {
    button: '.login-cta__options',
    mobileButton: '.login-cta__options_mobile',
    menu: '.login-cta__menu',
    menuOpen: 'login-cta__menu--open',
    menuState: 'closed',
    buttonOpen: 'login-cta__options--open',
    buttonClosed: 'login-cta__options--closed',
    mobileButtonOpen: 'login-cta__options_mobile--open',
    mobileButtonClosed: 'login-cta__options_mobile--closed'
};